import { Divider, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import Content from '../components/Layout/Content';
import { Box } from '@mui/system';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import PaginationComponent from '../components/paginationComponent/ServerSidePaginationComponent';
import {
  handleTimeFilter,
  handleStatusFilter,
  searchDataByKey,
  coverageArrayConvertor,
  formatDateInMMDDYYYYWithComma,
  extractValueFromRefDisplayJson,
  getJsonInfoFromReference,
  calculateDateFilterTimeStamp,
  getStatusFilterParamList,
} from '../shared/helper';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import SearchBar from '../components/SearchBar/Search';
import {
  coverageStatusFilterDatas,
  DEFAULT_NULL_REPLACEMENT,
  NUMBER_OF_ROWS_PER_PAGE,
  dateFilterMenuItems,
  COVERAGE_STATUS_LIST,
} from '../shared/constants';
import { ServiceFlyout } from '../components/ServiceFlyout/ServiceFlyout';
import { getIconFromSubItemsArray } from '../shared/helper';
import ApplicationContext from '../context/applicationContext';
import { useLazyQuery } from '@apollo/client';
import {
  FETCH_ALL_COVERAGES_QUERY,
  FETCH_PARTNER_COVERAGE_BY_ID_QUERY,
} from '../services/CoverageQueries/CoverageQueries';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import { useSnackbar } from 'notistack';
import NotFound from '../components/NotFound/NotFoundPage';
import { useNavigate } from 'react-router-dom';
import {
  COVERAGE,
  COVERAGE_TABLE_HEADING as tableHeading,
  COVERAGE_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

const Spending = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '0.5px solid gray',
        borderRadius: '16px',
        width: '350px',
        padding: '16px',
      }}>
      <Typography variant="h3" style={{ marginBottom: '8px' }}>
        Spending
      </Typography>
      <Divider />
      <Box sx={{ display: 'flex', flexDirection: 'column', margin: '8px 0px' }}>
        <Typography sx={{ color: '#828282' }}>Deductible</Typography>
        <Typography>$219.27 of $3,500.00 spent</Typography>
      </Box>
      <Divider />
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '8px' }}>
        <Typography sx={{ color: '#828282' }}>Out-of-Pocket Max</Typography>
        <Typography>$219.27 of $6,0000.00 spent</Typography>
      </Box>
    </Box>
  );
};

export const Coverage = () => {
  const [searchValue, setSearchValue] = useState('');
  const [recordsData, setRecordedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [timeFilter, setTimeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const { menuItems } = useContext(ApplicationContext);
  const [detailsData, setDetailsData] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [coverageIdForFlyout, setCoverageIdForFlyout] = useState();
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);
  const [openFlyout, setOpenFlyout] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  // const allCoverages = useQuery(FETCH_ALL_COVERAGES_QUERY, {
  //   variables: {
  //     sourceUrl: '',
  //     count: '10',
  //     offset: 0,
  //     dateFilter: 0,
  //     statusFilter: '',
  //     searchFilter: '',
  //   },
  // });

  const handleChangeFilter = () => {
    setOffset(0);
  };

  const [fetchAllCoverages, fetchAllCoveragesCall] = useLazyQuery(
    FETCH_ALL_COVERAGES_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(COVERAGE.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let result = res.getCoverages.coverageList;
        let convetor = JSON.parse(result);
        let data = coverageArrayConvertor(convetor);
        setRecordedData(data);
        setFilteredData(data);
        setTotalCount(res.getCoverages.count);
      },
    }
  );

  const [fetchPartnerCoverageById, fetchPartnerCoverageByIdCall] = useLazyQuery(
    FETCH_PARTNER_COVERAGE_BY_ID_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(COVERAGE.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        showFlyout(res);
      },
    }
  );

  useEffect(() => {
    fetchAllCoverages({
      variables: {
        sourceUrl: '',
        count: NUMBER_OF_ROWS_PER_PAGE.toString(),
        offset: offset,
        dateFilter: calculateDateFilterTimeStamp(timeFilter) || 0,
        statusFilter: getStatusFilterParamList(
          statusFilter,
          coverageStatusFilterDatas,
          COVERAGE_STATUS_LIST
        ),
        searchFilter: searchValue,
      },
    });
  }, [offset, searchValue, timeFilter]);

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const detailsLoading = fetchPartnerCoverageByIdCall.loading;
  const closeFlyout = () => {
    setOpenFlyout(false);
  };

  const viewDetailsHandler = coverageId => {
    const { id } = coverageId;
    fetchPartnerCoverageById({
      variables: {
        coverageId: id,
      },
    });
  };
  const viewPriceListButtonFromFlyoutHandler = (id, title) => {
    navigate(`/financial/coverage/coveragepricelist/${id}`, {
      state: {
        title: title,
      },
    });
  };
  const onSearch = text => {
    setSearchValue(text);
    offset !== 0 && setOffset(0);
  };

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const statusFilterOptions = {
    options: coverageStatusFilterDatas,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const showFlyout = result => {
    const parsedData = JSON.parse(result?.fetchPartnerCoverageById?.coverage);

    let policyNoConst = null;
    let planIdConst = null;
    let relationshipLocal = parsedData?.relationship?.coding
      ? parsedData?.relationship?.coding[0]?.display || DEFAULT_NULL_REPLACEMENT
      : DEFAULT_NULL_REPLACEMENT;
    if (
      parsedData?.relationship?.coding &&
      (relationshipLocal === '-' || relationshipLocal === null)
    ) {
      relationshipLocal =
        parsedData?.relationship?.coding[0]?.code || DEFAULT_NULL_REPLACEMENT;
    }
    if (relationshipLocal === '-' || relationshipLocal === null) {
      relationshipLocal =
        parsedData?.relationship?.text || DEFAULT_NULL_REPLACEMENT;
    }

    parsedData.identifier.map(val =>
      val.system === 'policy_number' && policyNoConst === null
        ? (policyNoConst = val.value)
        : null
    );
    parsedData.identifier.map(val =>
      val.system === 'plan_id' && planIdConst === null
        ? (planIdConst = val.value)
        : null
    );
    const modalData = [
      {
        column_name: COVERAGE.MODAL_DATA.STATUS,
        value: parsedData?.status || DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.RECORDED_ON,
        value:
          formatDateInMMDDYYYYWithComma(parsedData?.period?.start) ||
          DEFAULT_NULL_REPLACEMENT,
      },

      {
        column_name: COVERAGE.MODAL_DATA.POLICY_NUMBER,
        value: policyNoConst != null ? policyNoConst : DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.SUBSCRIBER_ID,
        value: parsedData?.subscriberId || DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.SUBSCRIBER_NAME,
        value:
          parsedData?.subscriber?.display ||
          /*JSON.parse(parsedData?.subscriber?.display)['subscriber-name'] ||*/
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.RELATIONSHIP,

        value: relationshipLocal,
      },
      {
        column_name: COVERAGE.MODAL_DATA.PLAN_TYPE,
        value:
          parsedData?.class[0]?.type?.coding[0]?.code ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.PLAN_ID,
        value: planIdConst != null ? planIdConst : DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.COVERAGE_TYPE,
        value:
          parsedData?.type?.coding[0]?.display ||
          parsedData?.type?.text ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.ISSUER_ORGANISATION,
        value: parsedData?.payor[0]?.display || DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.START_DATE,
        value:
          formatDateInMMDDYYYYWithComma(parsedData?.period?.start) ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: COVERAGE.MODAL_DATA.END_DATE,
        value:
          formatDateInMMDDYYYYWithComma(parsedData?.period?.end) ||
          DEFAULT_NULL_REPLACEMENT,
      },

      {
        column_name: COVERAGE.MODAL_DATA.TOTAL_AMOUNT,
        value:
          '$' +
          (parsedData?.costToBeneficiary[0]?.valueQuantity?.value ||
            parsedData?.costToBeneficiary[0]?.valueMoney?.value ||
            DEFAULT_NULL_REPLACEMENT),
      },

      {
        column_name: COVERAGE.MODAL_DATA.CONTACT_NAME,
        value:
          extractValueFromRefDisplayJson(
            getJsonInfoFromReference(parsedData?.policyHolder?.display),
            'contact-name'
          ) || DEFAULT_NULL_REPLACEMENT,
        //JSON.parse(parsedData?.policyHolder?.display)['policy-holder-name'] ||
        // DEFAULT_NULL_REPLACEMENT,
      },

      {
        column_name: COVERAGE.MODAL_DATA.CONTACT_PHONE_NUMBER,
        value:
          extractValueFromRefDisplayJson(
            getJsonInfoFromReference(parsedData?.policyHolder?.display),
            'contact-phone'
          ) || DEFAULT_NULL_REPLACEMENT,
      },

      {
        column_name: COVERAGE.MODAL_DATA.CONTACT_ADDRESS,
        value:
          extractValueFromRefDisplayJson(
            getJsonInfoFromReference(parsedData?.policyHolder?.display),
            'contact-address'
          ) || DEFAULT_NULL_REPLACEMENT,

        width: 12,
      },
      {
        column_name: COVERAGE.MODAL_DATA.NOTE,
        value: parsedData?.extension
          ? parsedData?.extension[0]?.valueString
          : DEFAULT_NULL_REPLACEMENT,
        width: 12,
      },
      {
        column_name: COVERAGE.MODAL_DATA.DOCUMENTS,
        value:
          result?.fetchPartnerCoverageById?.docArn[0] ||
          DEFAULT_NULL_REPLACEMENT,
      },
    ];
    setCoverageIdForFlyout(planIdConst);
    setModalTitle(parsedData?.class[0]?.name || DEFAULT_NULL_REPLACEMENT);
    setDetailsData(modalData);
    setOpenFlyout(true);
  };

  return (
    <Content>
      <BreadcrumbComponent breadcrumbData={breadcrumbData} />
      <div>
        <Typography variant="title">{COVERAGE.TITLE_TEXT}</Typography>
        <Box sx={{ display: 'flex', position: 'relative', top: 40 }}>
          <SearchBar
            sx={{
              width: '50%',
              minWidth: '250px',
              maxWidth: '500px',
              marginTop: '8px',
            }}
            onSearch={onSearch}
            placeholder={COVERAGE.SEARCH_PLACEHOLDER_TEXT}
          />
          <FilterDropDown {...dateFilterOptions} filterType="Date:" />
          <FilterDropDown {...statusFilterOptions} filterType="Status:" />
        </Box>
        <Box sx={table}>
          {!fetchAllCoveragesCall.loading && !filteredData.length ? (
            <NotFound title={COVERAGE.TITLE_TEXT} />
          ) : (
            <>
              <ReusableTable
                tableHeading={tableHeading}
                data={filteredData}
                viewDetailsHandler={viewDetailsHandler}
                viewPriceHandler={viewPriceListButtonFromFlyoutHandler}
              />
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 18,
                }}>
                {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
                  <PaginationComponent
                    numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
                    count={totalCount}
                    onPageClick={onPageClick}
                    page={offset / 10}
                  />
                )}
              </div>
            </>
          )}
        </Box>
        <ServiceFlyout
          isOpen={openFlyout}
          handleClose={closeFlyout}
          data={detailsData}
          showSecondaryButton={true}
          showBenefits={true}
          secondaryButtonTitle="View Price List"
          handlerClickSecondaryButton={viewPriceListButtonFromFlyoutHandler}
          icon={
            menuItems
              ? getIconFromSubItemsArray(
                  menuItems?.Financial?.subItems,
                  'Coverage and benefits'
                )
              : null
          }
          id={coverageIdForFlyout}
          category={COVERAGE.TITLE_TEXT}
          title={modalTitle}>
          <Spending />
        </ServiceFlyout>
      </div>
      <SimpleBackdrop open={fetchAllCoveragesCall.loading || detailsLoading} />
    </Content>
  );
};
